import React, { Component } from 'react';
import _ from 'lodash';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import Spinner from '../../../components/Widgets/spinner';
import SpinnerButton from '../../Common/SpinnerButton';
import {
  getProductImages,
  updateProductImages,
  deleteProductImages,
} from '../../../actions/products_actions';
import { isSY, isJML } from '../../../actions/root_url';

const {
  Draggable: { Container: DraggableContainer, RowActionsCell, DropTargetRowContainer },
  Data: { Selectors },
} = require('react-data-grid-addons');

const RowRenderer = DropTargetRowContainer(ReactDataGrid.Row);

const ThumbnailFormatter = React.createClass({
  render() {
    return (
      <div id="product-image-container">
        <Dropzone
          onDrop={this.props.onDrop.bind(this.props.dependentValues.Index, this)}
          className="product-image-dropzone"
          accept="image/*"
        >
          {this.props.renderImage(this.props.dependentValues.Index)}
          <Button
            id="dropzone-button"
            bsStyle="primary"
            type="button"
          >
            <em className="fa fa-plus" />
          </Button>
        </Dropzone>
        <div className="default-placeholder">
          {
            this.props.dependentValues.Index === 0 &&
              <div >
                <Translate value="default" />
              </div>
          }
        </div>
      </div>
    );
  },
});

const propTypes = {
  rowKey: PropTypes.string,
  productId: PropTypes.number,
  handleImageUpdated: PropTypes.func,
};

const defaultProps = {
  rowKey: 'Index',
  productId: undefined,
  handleImageUpdated: () => {},
};

class ProductImagesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      selectedRows: null,
      sortColumn: null,
      sortDirection: null,

      isLoadingImages: false,
      isSavingImages: false,
      isDeletingImage: false,
    };
    this.addMultiNewImages = this.addMultiNewImages.bind(this);
  }

  componentDidMount() {
    this.fetchImages();
  }

  onDrop = (row, files) => {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const index = row.props.rowIdx;
      const newRows = [...this.state.rows];
      newRows[index].ImageString = reader.result;
      this.setState({ rows: newRows });
    };
    // get the first file and convert to blob object (Blob.slice([start [, end [, contentType]]))
    const blob = files[0].slice(0, files[0].size, files[0].type);
    reader.readAsDataURL(blob);
  }

  handleSaveImages = () => {
    const rows = this.state.rows.filter((row) => {
      const match = !(row.ImageString === undefined && row.ProductImage_id === undefined);
      return match;
    });
    rows.map((row, index) => {
      row.IsDefault = (index === 0); // Mark first image default
      row.Order = index;
    });
    this.setState({ rows }, () => {
      this.saveImages(() => {
        const defaultImage = _.find(rows, { IsDefault: true });
        const updatedImage = defaultImage && (defaultImage.ImageString || defaultImage.MediumImage);
        this.props.handleImageUpdated(updatedImage);
        this.fetchImages();
      });
    });
  }

  addMultiNewImages = () => {
    const rows = Data.Selectors.getRows(this.state);
    const newRows = [...this.state.rows];

    var inputElement = document.getElementById('imgFile');
    if(inputElement == null) {
      inputElement = document.createElement('input');
    }
    inputElement.id = 'imgFile'
    inputElement.type = 'file';
    inputElement.style.opacity = 0;
    inputElement.multiple = true;
    inputElement.onchange = (event) => {
      event.preventDefault();
      let files = event.target.files;
      if (files.length == 0) {
        return;
      }
      const index = rows.length;
      let k = 0;
      let max = 20;
      if(index + files.length < 20) {
        max = index + files.length;
      }
      for (let i = index; i < max; i++) {
       let file = files[k];
       k++;
       const reader = new FileReader();
       reader.onload = () => {
        let row = {Index: i, ImageString: reader.result};
        newRows.push(row);
        this.setState({ rows: newRows });
       };
      const blob = file.slice(0, file.size, file.type);
      reader.readAsDataURL(blob);
      }
    }
    var divElement = document.getElementById('product-images-modal');
    divElement.appendChild(inputElement);
    inputElement.click();
  }
  addNewImageRow = (e) => {
    e.preventDefault();
    
    const rows = Data.Selectors.getRows(this.state);
    let maxCount = 4;
    if(isSY) {
      maxCount = 12;
    }
    if(isJML) {
      maxCount = 20;
    }
    if (rows.length === maxCount) {
      alert(`Max of ${maxCount} images!`);
      return;
    }
    if(isJML) {
      this.addMultiNewImages();
      return
    }
    const index = rows.length;
    const newRow = {
      Index: index,
    };
    rows.push(newRow);
    this.setState({ rows });
  }

  deleteRow = () => {
    const { selectedRows } = this.state;
    if (!selectedRows || selectedRows.length === 0) {
      alert('Select a row to delete!');
      return;
    }
    const { ProductImage_id: id } = selectedRows[0];
    if (id) {
      this.deleteImage(id, () => this.fetchImages());
    } else {
      const rows = [...this.state.rows];
      const index = _.findIndex(rows, { Index: selectedRows[0].Index });
      rows.map((row, rowIndex) => {
        row.Index = rowIndex;
      });
      rows.splice(index, 1);
      this.setState({ rows, selectedRows: [] });
    }
  }

  fetchImages = () => {
    const handleSuccess = (response) => {
      const rows = response.Images;
      rows.map((row, index) => {
        row.Index = index;
      });
      this.setState({
        rows,
        isLoadingImages: false,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        // rows: [],
        isLoadingImages: false,
      });
    };
    this.setState({
      isLoadingImages: true,
    }, () => getProductImages(this.props.productId, handleSuccess, handleFailure));
  }

  saveImages = (successCallback) => {
    const handleSuccess = (response) => {
      this.setState({
        isSavingImages: false,
      }, successCallback);
    };
    const handleFailure = (error) => {
      let msg = "Error: ";
      // if (JSON.stringify(error).length > 250) {
      //   msg += JSON.stringify(error).substring(0, 250);
      // } else {
        msg += JSON.stringify(error);
      // }
      alert(msg);
      this.setState({
        isSavingImages: false,
      });
    };
    this.setState({
      isSavingImages: true,
    }, () => updateProductImages(this.props.productId, this.state.rows, handleSuccess, handleFailure));
  }

  deleteImage = (imageId, successCallback) => {
    const handleSuccess = (response) => {
      this.setState({
        isDeletingImage: false,
      }, successCallback);
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        isDeletingImage: false,
      });
    };
    this.setState({
      isDeletingImage: true,
    }, () => deleteProductImages(imageId, handleSuccess, handleFailure));
  }

  renderImage = (index) => {
    const imageFile = ((this.state.rows[index].ImageString || this.state.rows[index].LargeImage) || '/img/dummy.png');
    return (
      <div className="img-view">
        <img
          src={imageFile}
          alt="Upload"
          className="default-image"
        />
      </div>
    );
  }

  renderTable() {
    if (this.state.isLoadingImages) {
      return <Spinner />;
    }
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      this.setState({ rows });
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({
        rows: newRows, selectedRows: [rows[0].row],
      });
    };

    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    };

    const isDraggedRowSelected = (selectedRows, rowDragSource) => {
      if (selectedRows && selectedRows.length > 0) {
        const key = this.props.rowKey;
        return selectedRows.filter(r => r[key] === rowDragSource.data[key]).length > 0;
      }
      return false;
    };

    const reorderRows = (e) => {
      const selectedRows = Selectors.getSelectedRowsByKey({ rowKey: this.props.rowKey, selectedKeys: [], rows: this.state.rows });
      const draggedRows = isDraggedRowSelected(selectedRows, e.rowSource) ? selectedRows : [e.rowSource.data];
      const undraggedRows = this.state.rows.filter(r => draggedRows.indexOf(r) === -1);
      const args = [e.rowTarget.idx, 0].concat(draggedRows);
      Array.prototype.splice.apply(undraggedRows, args);
      undraggedRows.map((row, index) => {
        row.Index = index;
      });
      this.setState({ rows: undraggedRows });
    };

    const columns = [
      {
        key: 'Thumbnail',
        name: <Translate value="thumbnail" />,
        resizeable: true,
        width: 500,
        sortable: false,
        editable: false,
        filterable: false,
        formatter: <ThumbnailFormatter renderImage={this.renderImage} onDrop={this.onDrop} />,
        getRowMetaData: row => row,
      },
    ];

    return (
      <div className="images-modal" key={Math.random()}>
        <DraggableContainer>
          <ReactDataGrid
            columns={columns}
            enableCellSelect
            minHeight={550}
            rowHeight={180}
            headerRowHeight={25}
            enableRowSelect="single"
            onRowUpdated={handleRowUpdated}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            rowActionsCell={RowActionsCell}
            rowRenderer={<RowRenderer onRowDrop={reorderRows} />}
            rowSelection={{
              showCheckbox: true,
              onRowsSelected,
              onRowsDeselected,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            }}
          />
        </DraggableContainer>
      </div>
    );
  }

  render() {
    const { isSavingImages, isDeletingImage } = this.state;
    return (
      <ContentWrapper>
        <div id="product-images-modal">
          <div className="toolbar-row">
            <ButtonToolbar>
              <SpinnerButton
                bsStyle="success"
                disabled={isSavingImages}
                onClick={this.handleSaveImages}
                loading={isSavingImages}
                icon="fa-save"
                translation={<Translate value="save" />}
              />
              <Button
                bsStyle="primary"
                onClick={this.addNewImageRow}
              >
                <em className="fa fa-plus" /><Translate value="create" />
              </Button>
              <SpinnerButton
                bsStyle="danger"
                disabled={isDeletingImage}
                onClick={this.deleteRow}
                loading={isDeletingImage}
                icon="fa-trash"
                translation={<Translate value="delete" />}
              />
            </ButtonToolbar>
            <div className="toolbar-desc">
              <Translate value="msg_product_image_modal_desc" />
            </div>
          </div>
          <div style={{marginTop: '3px', marginBottom: '3px'}}>
            <span style={{color: 'red'}}><Translate value="image_size_limit" /></span>
          </div>
          {/* <br /> */}
          {this.renderTable()}
        </div>
      </ContentWrapper>
    );
  }
}

ProductImagesTable.propTypes = propTypes;
ProductImagesTable.defaultProps = defaultProps;

export default ProductImagesTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/ProductImagesTable.jsx